<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)"
>
</app-ship-details>

<form
  id="askSecQuestions-form"
  name="askSecQuestionsForm"
  class="form-horizontal"
  autocomplete="off"
  novalidate
  angular-Validator
>
  <div
    *ngIf="
      passwords == 'false' &&
      hasEntitlements('SHIPS_ACCESS_PASSWORDS')
    "
    class="card card-nc"
  >
    <div class="card-heading">
      <div class="card-title clearfix">
        <i class="fa fa-lock"></i>
        <span class="panelHeaderHeading"> Ship Access Details </span>
      </div>
    </div>
    <div class="card-body">
      <span class="form-group pull-left">
          <button
            id="show_pass_button"
            name="toggleButton1"
            class="btn btn-nc"
            type="button"
            value="button"
            (click)="showPassword()"
          >
            SHOW PASSWORDS
          </button>
        </span>
    </div>
  </div>
</form>
<div
  *ngIf="passwords == 'true' && hasEntitlements('SHIPS_ACCESS_PASSWORDS')"
  class="card card-nc"
>
  <div class="card-heading">
    <div class="card-title">
      <i class="fa fa-lock"></i>
      <span class="panelHeaderHeading"> Ship Access Details </span>
    </div>
  </div>
  <div class="card-body">
    <div class="form-group pull-left">
      <button
        id="hide_pass_button"
        name="toggleButton2"
        class="btn btn-nc btn-block"
        type="button"
        value="button"
        (click)="hidePasswords()"
      >
        HIDE PASSWORDS
      </button>
    </div>
  </div>

  <div class="card-body">
    <i [ngClass]="shipPasswordSpinner"></i>
    <div class="row" style="padding: 25px" *ngIf="showSpellingError">
      <div class="col-md-6">
        <div class="col-md-12 labelCommon zeroPadding">
          Passwords not configured for this ship.
        </div>
      </div>
    </div>
    <div class="row" style="padding: 25px" *ngIf="spellingList0">
      <div class="col-md-6">
        <div class="col-md-12 labelBlueBold zeroPadding">
          {{ shipPassword[0].username }}
        </div>
        <div
          class="col-md-12 zeroPadding"
          style="font: italic bold 12px/30px Georgia, serif"
        >
          {{ shipPassword[0].password }}
        </div>
        <div class="form-group col-md-12 staticText1">
          <div class="col-md-1" style="width: 2.33333%;"></div>
          <div class="col-md-3">&nbsp;</div>
          <div class="col-md-12 passwordBorder">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 labelBlueBold passwordCell">
                  PHONETIC SPELLING
                </div>
                <div
                  class="col-md-4 passwordCell text-nowrap noteDetailText"
                  *ngFor="let spelling of spellingList0"
                  [innerHTML]="spelling | phoneticColor"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="spellingList1">
        <div class="col-md-12 labelBlueBold zeroPadding">
          {{ shipPassword[1].username }}
        </div>
        <div
          class="col-md-12 zeroPadding"
          style="font: italic bold 12px/30px Georgia, serif"
        >
          {{ shipPassword[1].password }}
        </div>
        <div class="form-group col-md-12 staticText1">
          <div class="col-md-1" style="width: 2.33333%;"></div>
          <div class="col-md-3">&nbsp;</div>
          <div class="col-md-12 passwordBorder">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 labelBlueBold passwordCell">
                  PHONETIC SPELLING
                </div>
                <div
                  class="col-md-4 passwordCell text-nowrap noteDetailText"
                  *ngFor="let spelling of spellingList1"
                  [innerHTML]="spelling | phoneticColor"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="padding: 25px" *ngIf="spellingList2">
      <div class="col-md-6">
        <div class="col-md-12 labelBlueBold zeroPadding">
          {{ shipPassword[2].username }}
        </div>
        <div
          class="col-md-12 zeroPadding"
          style="font: italic bold 12px/30px Georgia, serif"
        >
          {{ shipPassword[2].password }}
        </div>
        <div class="form-group col-md-12 staticText1">
          <div class="col-md-1" style="width: 2.33333%;"></div>
          <div class="col-md-3">&nbsp;</div>
          <div class="col-md-12 passwordBorder">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 labelBlueBold passwordCell">
                  PHONETIC SPELLING
                </div>
                <div
                  class="col-md-4 passwordCell text-nowrap noteDetailText"
                  *ngFor="let spelling of spellingList2"
                  [innerHTML]="spelling | phoneticColor"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="col-md-12 labelBlueBold zeroPadding">
          &nbsp;
        </div>
        <div
          class="col-md-12 zeroPadding"
          style="font: italic bold 12px/30px Georgia, serif" >&nbsp;
        </div>
        <div class="form-group col-md-12 staticText1">
          <div class="col-md-1" style="width: 2.33333%;"></div>
          <div class="col-md-3">&nbsp;</div>
          <div class="col-md-12 passwordBorder">
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-md-12 labelBlueBold passwordCell">
                  Last Update: {{passMonth}}/{{passDay}}/{{passYear}}
                </div>
                <div class="col-md-12 labelBlueBold passwordCell">
                  Legacy Shore Web Services Status:  {{ webSerStatus }}
                </div>
                <div class="col-md-12 labelBlueBold passwordCell" *ngIf="isLocked()">
                  <button
                    type="submit"
                    (click)="unlockStatus()"
                    class="btn btn-nc"  >
                    UNLOCK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
